import { toggleModal } from "../../utils/uiUtils";
import { _saveUserDisplayName, _getUser } from "../../data/users";
import { useEffect, useState } from "react";

function UserSettingsChangeName({ setUserLoading }) {
    const [user, setUser] = useState({});
    const [isLoadingUser, setIsLoadingUser] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            const tmpUser = await _getUser();
            setUser(tmpUser);
            setUserLoading(false);
            setIsLoadingUser(false);
        };

        fetchData();
    }, []);

    const saveNewDisplayName = async () => {
        var newDisplayName = document.getElementById("changeDisplayNameTo").value;
        var changeInAllGroups = document.getElementById("changeInAllGroups").checked;
        await _saveUserDisplayName(newDisplayName, changeInAllGroups);
        const tmpUser = await _getUser();
        setUser(tmpUser);
        toggleModal("modal-changeDisplayName");
    }

    if (isLoadingUser)
        return (<></>);

    return (
        <>
            <div className="is-size-5 has-text-weight-bold is-underlined">
                User Information
            </div>
            <div>
                Date Joined: {user.dateJoined.toDate().toLocaleDateString()}
            </div>

            <div>
                Last Login: {user.lastLogin.toDate().toLocaleDateString()}
            </div>
            <div>
                Your current default display name is <span className="has-text-weight-bold">{user.displayName}</span>.
                Each group you're in can have a different display name, and you can change it on a group by group basis (in the Group Members page).
                You can also change your default name for future groups, or for all groups that you are currently in.
            </div>
            <div>
                <button className="button is-primary is-small is-rounded mt-3" onClick={() => { toggleModal("modal-changeDisplayName")}}>Change Default Name</button>
            </div>

            <div id="modal-changeDisplayName" className="modal">
                <div className="modal-background"></div>
                <div className="modal-card">
                    <header className="modal-card-head has-text-centered">
                        <p className="modal-card-title">Change Default Display Name</p>
                        <button className="delete" aria-label="close" onClick={() => { toggleModal('modal-changeDisplayName') }}></button>
                    </header>
                    <section className="modal-card-body">
                        <div className="is-size-6">
                            This will change your default display name for future groups you create/join.   
                        </div>
                        <div>
                            <input type="hidden" id="changeDisplayNameId"></input>
                            <input type="text" className="input is-rounded" maxLength="50" id="changeDisplayNameTo" placeholder={user.displayName}></input>
                        </div>
                        <div className="field mt-3 ml-3">
                            <label className="checkbox">
                                <input type="checkbox" id="changeInAllGroups" className="mr-2" />
                                Change Name In All Groups
                            </label>
                        </div>
                    </section>
                    <footer className="modal-card-foot">
                        <button
                            className="button is-primary mr-2"
                            onClick={async () => { saveNewDisplayName() }}>
                            Save New Name
                        </button>
                        <button className="button" aria-label="close" onClick={() => { toggleModal('modal-changeDisplayName') }}>Close</button>
                    </footer>
                </div>
            </div>
        </>
    )
}

export default UserSettingsChangeName;